import { ReactNode } from 'react'

import { Header } from 'components/header'

import { Wrapper, Container } from './styled'

type MainProps = {
  children: ReactNode
}

export function Main({ children }: MainProps): JSX.Element {
  return (
    <Wrapper>
      <Header />
      <Container>{children}</Container>
    </Wrapper>
  )
}
